import { useController, UseControllerProps } from 'react-hook-form'

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Switch } from '@/components/ui/switch'

interface Props {
  label?: string
  positionLabel?: 'left' | 'right'
}

export const ToggleForm = (props: Props & UseControllerProps) => {
  const { control, name, label, positionLabel = 'left' } = props
  const { fieldState } = useController(props)
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <div className="flex items-center space-x-2">
              {label && positionLabel === 'left' && (
                <FormLabel htmlFor={name}>{label}</FormLabel>
              )}
              <Switch checked={field.value} onCheckedChange={field.onChange} />
              {label && positionLabel === 'right' && (
                <FormLabel htmlFor={name}>{label}</FormLabel>
              )}
            </div>
          </FormControl>
          <FormMessage>{fieldState.error?.message}</FormMessage>
        </FormItem>
      )}
    />
  )
}
